import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconHomeHouse = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    stroke: color,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "20",
    x2: "20",
    y1: "10.55",
    y2: "21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12l-9.375-6.815 -2.48389e-08-1.79863e-08c-.349944-.253401-.823056-.253401-1.173 3.59727e-08l-9.452 6.815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.743v-5.243 0c0-.276142-.223858-.5-.5-.5h-3l-2.18557e-08 8.88178e-16c-.276142 1.20706e-08-.5.223858-.5.5 0 0 0 0 0 0v2.609"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "22",
    x2: "2",
    y1: "21",
    y2: "21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4",
    x2: "4",
    y1: "10.56",
    y2: "21"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "4",
    height: "3",
    x: "13.5",
    y: "15",
    rx: ".27614",
    ry: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21v-5.5l5.32907e-15 7.54979e-08c-4.16963e-08-.276142.223858-.5.5-.5h2.5 -2.18557e-08c.276142-1.20706e-08.5.223858.5.5v5.5"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "none"
  }));
};
//# sourceMappingURL=IconHomeHouse.js.map